import type { englishJobMessages, englishNavMessages } from "./jobMessages";

type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };

export const vietnameseJobMessages = {
  name: "Phiếu công trình |||| Phiếu công trình",
  list: {
    title: "Hồ sơ đo đạc & đơn hàng",
    subtitle: "Sắp xếp theo công trình mới phát sinh gần nhất",
    search_placeholder: "Tìm khách hàng, SĐT, địa chỉ, mã phiếu…",
    showing: "Đang hiện %{count} phiếu",
    kpi_total: "Tổng công trình",
    kpi_total_hint: "%{count} công trình đã chốt đơn",
    kpi_revenue: "Doanh số đã chốt",
    kpi_revenue_hint: "Chờ chốt: %{amount}",
    kpi_collected: "Thực thu tiền mặt / CK",
    kpi_collected_hint: "%{percent}% doanh số đã chốt",
    kpi_receivable: "Công nợ phải thu còn lại",
    kpi_receivable_hint: "%{count} công trình chưa hoàn tất thanh toán",
    filter_status: "Trạng thái công trình",
    filter_payment: "Tình trạng thanh toán",
    filter_sales_rep: "NV phụ trách",
    filter_care_rep: "NV chăm sóc",
    filter_month: "Tháng",
    filter_line: "Ngành hàng",
    all_statuses: "Tất cả trạng thái",
    all_payments: "Tất cả thanh toán",
    all_staff: "Tất cả nhân viên",
    all_months: "Tất cả các tháng",
    all_lines: "Tất cả ngành hàng",
    clear_filters: "Xóa lọc",
    col_customer: "Tên khách hàng & địa chỉ",
    col_products: "Sản phẩm",
    col_date_staff: "Ngày lập & nhân sự",
    col_status: "Tiến độ thi công",
    col_payment: "Thanh toán",
    col_total: "Tổng giá trị & còn lại",
    sales_rep_short: "Phụ trách:",
    care_rep_short: "Chăm sóc:",
    remaining: "Còn: %{amount}",
    paid_in_full: "Đã thu đủ 100%",
    deposit_amount: "Đã cọc %{amount}",
    show_more: "Xem thêm %{count} phiếu",
    empty: "Không có phiếu nào khớp bộ lọc.",
    new_job: "Tạo phiếu mới",
    new_job_hint: "Phiếu báo giá mới vẫn tạo trên công cụ báo giá hiện tại",
    export: "Xuất báo cáo",
    import: "Nhập từ Google Sheet",
  },
  import: {
    title: "Nhập dữ liệu từ Google Sheet",
    description:
      "Trong Google Sheet, mở từng tab (CongTrinh, LichSu, CaiDat) rồi chọn Tệp > Tải xuống > CSV, sau đó chọn các file ở đây. Phiếu đã có sẽ được cập nhật theo mã phiếu, nên có thể nhập lại bất cứ lúc nào.",
    choose_files: "File CSV",
    start: "Nhập dữ liệu",
    running: "Đang nhập… %{done} / %{total}",
    done: "Đã nhập %{jobs} phiếu, %{versions} phiên bản và %{settings} mục cài đặt.",
    unknown_file:
      "%{name}: không phải file xuất từ tab CongTrinh, LichSu hoặc CaiDat.",
    error: "Nhập dữ liệu thất bại: %{message}",
  },
  show: {
    back: "Danh sách công trình",
    open_legacy: "Mở trên công cụ báo giá",
    doors: "%{count} cửa",
    products: "%{count} sản phẩm",
    version: "Phiên bản %{version} · %{date}",
    steps: {
      measure: "Đo đạc",
      quote: "Báo giá",
      order: "Đặt hàng",
      docs: "Hồ sơ",
      tracking: "Theo dõi & Thu tiền",
    },
  },
  measure: {
    survey_title: "Hồ sơ khảo sát hiện trường",
    phone: "Điện thoại",
    address: "Địa chỉ",
    zalo: "Zalo",
    date: "Ngày đo",
    measurer: "Kỹ thuật viên đo",
    progress_title: "Tiến độ đo đạc",
    progress_hint: "%{done} / %{total} cửa đã có số đo",
    warnings:
      "Phát hiện %{count} dòng thiếu dữ liệu kỹ thuật (số đo hoặc mã sản phẩm).",
    table_title: "Bảng ghi số đo hiện trường",
    unit_hint: "Đơn vị đo: mét (m) · Tự động tính diện tích m² & m ngang",
    col_position: "Vị trí cửa",
    col_type: "Loại rèm",
    col_code: "Mã vải / bản lá",
    col_sewing: "Quy cách may / khung",
    col_sheer: "Lớp voan",
    col_mount: "Kiểu lắp",
    col_width: "Rộng (m)",
    col_height: "Cao (m)",
    col_qty: "SL",
    col_billable: "KL tính",
    col_state: "Trạng thái",
    col_note: "Ghi chú",
    state_ok: "Đã đo đủ",
    state_missing_size: "Thiếu số đo",
    state_missing_code: "Thiếu mã",
    no_rows:
      "Phiếu này được nhập từ file Công trình 2026 nên không có bảng số đo. Tổng tiền giữ nguyên như đã ghi.",
  },
  quote: {
    lines_title: "Bảng phân rã chi tiết hạng mục",
    col_item: "Hạng mục & quy cách",
    col_unit: "ĐVT",
    col_unit_price: "Đơn giá (đ)",
    col_amount: "Thành tiền (đ)",
    info_title: "Thông tin báo giá",
    date: "Ngày báo giá",
    sales: "Nhân viên sale",
    notes: "Ghi chú & quy định báo giá",
    totals_title: "Tổng cộng báo giá",
    subtotal: "Cộng tiền hàng",
    discount: "Ưu đãi / chiết khấu",
    vat: "Thuế GTGT (VAT %{rate}%)",
    total: "TỔNG CỘNG",
    deposit: "Đặt cọc",
    remaining: "Còn lại khi bàn giao",
    none: "Không áp dụng",
    extras: "Hạng mục khác",
    mismatch:
      "Tổng tính lại khác với tổng đã lưu (%{amount}); các màn hình khác vẫn dùng tổng đã lưu.",
    legacy_actions:
      "PDF báo giá, file Google Sheet và ảnh gửi Zalo vẫn tạo trên công cụ báo giá hiện tại.",
    no_lines: "Phiếu này chưa có dòng nào có đơn giá.",
  },
  order: {
    title: "Thông tin lệnh sản xuất",
    ordered: "Đã đặt hàng xưởng",
    not_ordered: "Chưa gửi xưởng",
    order_date: "Ngày tạo đơn",
    need_by: "Ngày cần hàng",
    contact: "Người nhận / liên hệ",
    delivery: "Địa điểm nhận hàng",
    note: "Ghi chú vận chuyển & bàn giao xưởng",
    factory_title: "Phân chia đơn theo xưởng",
    factory_hint:
      "Bảng dành cho xưởng sản xuất: chỉ có kích thước, quy cách và vị trí lắp, tuyệt đối không có đơn giá.",
    supplier: "Xưởng: %{name}",
    unassigned: "Chưa chọn xưởng",
  },
  docs: {
    title: "Bộ hồ sơ pháp lý & hợp đồng",
    contract_no: "Số hợp đồng",
    party_a: "Bên A • Thông tin khách hàng / chủ đầu tư",
    customer: "Tên khách hàng / đơn vị",
    phone: "Số điện thoại liên hệ",
    address: "Địa chỉ thi công & nhận hóa đơn",
    total: "Tổng giá trị hợp đồng",
    in_words: "Bằng chữ",
    templates: "Loại biểu mẫu pháp lý",
    contract: "HĐKT + phụ lục",
    acceptance: "Biên bản nghiệm thu bàn giao",
    payment_request: "Đề nghị thanh toán",
    legacy_hint:
      'File Google Docs và PDF pháp lý vẫn tạo trên công cụ báo giá hiện tại, lưu trong thư mục Drive "HKH - Hồ sơ".',
  },
  tracking: {
    timeline_title: "Tiến độ thi công & sản xuất",
    payment_title: "Tình trạng thanh toán & tài chính",
    total: "Tổng giá trị phiếu",
    collected: "Đã thu (tạm ứng)",
    remaining: "Còn lại phải thu",
    progress: "Đã thu %{percent}%",
    edit_title: "Thông tin chung & nhân sự phụ trách",
    status: "Trạng thái",
    payment_status: "Thanh toán",
    deposit: "Đã thu (đ)",
    sales_rep: "NV phụ trách",
    care_rep: "NV chăm sóc",
    source: "Nguồn khách hàng",
    start_date: "Ngày bắt đầu",
    end_date: "Ngày kết thúc",
    notes: "Ghi chú",
    save: "Lưu thay đổi",
    saved: "Đã cập nhật phiếu",
    history_title: "Lịch sử chỉnh sửa & phiên bản",
    history_empty: "Chưa có phiên bản nào được lưu.",
    version_label: "Phiên bản %{version}",
  },
} satisfies Shape<typeof englishJobMessages>;

export const vietnameseNavMessages = {
  tagline: "Hệ thống đa ngành nội thất",
  section_lines: "Ngành hàng & dịch vụ",
  section_admin: "Quản trị hệ thống",
  dashboard: "Tổng quan",
  jobs: "Quản lý công trình",
  contacts: "Khách hàng (CRM)",
  companies: "Công ty / đối tác",
  deals: "Cơ hội bán hàng",
  price_book: "Sản phẩm & bảng giá",
  marketing: "Marketing & khuyến mãi",
  finance: "Thu chi & tài chính",
  users: "Nhân sự / người dùng",
  settings: "Cài đặt hệ thống",
  coming_soon: "Sắp có",
  lines: {
    curtain: "Rèm cửa & may đo",
    mattress: "Nệm & foam",
    bedding: "Chăn ga gối",
    screen: "Cửa lưới chống muỗi",
    dryer: "Giàn phơi thông minh",
  },
} satisfies Shape<typeof englishNavMessages>;
